module.exports = require("@workbench-stack/jsonschemas");